import React, { useEffect, useState } from 'react';
import { Keyboard, X } from 'lucide-react';
import { useLang } from './i18n';
import { KEYBIND_ACTIONS, KeybindAction, comboFromEvent, loadKeybinds, saveKeybinds } from './keybinds';

export function KeybindSettings() {
  const [, , tr] = useLang();
  const [binds, setBinds] = useState(loadKeybinds);
  const [recording, setRecording] = useState<KeybindAction | null>(null);
  useEffect(() => {
    if (!recording) return;
    const onKey = (e: KeyboardEvent) => {
      e.preventDefault(); e.stopPropagation();
      if (e.key === 'Escape') { setRecording(null); return; }
      const combo = comboFromEvent(e); if (!combo) return;
      const next = { ...binds };
      for (const k of Object.keys(next) as KeybindAction[]) if (next[k] === combo) delete next[k]; // one action per combo
      next[recording] = combo;
      setBinds(next); saveKeybinds(next); setRecording(null);
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [recording, binds]);
  const clear = (a: KeybindAction) => { const next = { ...binds }; delete next[a]; setBinds(next); saveKeybinds(next); };
  return (
    <>
      <h2>{tr('Keybinds', 'Tastenkürzel')}</h2>
      <p>{tr('Click a field and press the keys you want. Esc cancels. In the desktop app, shortcuts with Ctrl/Alt/Shift also work while MALVO is in the background.', 'Klicke auf ein Feld und drücke die gewünschten Tasten. Esc bricht ab. In der Desktop-App funktionieren Kürzel mit Strg/Alt/Shift auch, wenn MALVO im Hintergrund ist.')}</p>
      <div className="keybind-list">
        {KEYBIND_ACTIONS.map(a => (
          <div className="keybind-row" key={a.id}>
            <span className="keybind-label"><b>{tr(a.en, a.de)}</b><small>{tr(a.hintEn, a.hintDe)}</small></span>
            <button type="button" className={'keybind-capture' + (recording === a.id ? ' is-recording' : '') + (binds[a.id] ? ' has-key' : '')} onClick={() => setRecording(recording === a.id ? null : a.id)}>
              <Keyboard size={14} />
              {recording === a.id ? tr('Press keys…', 'Tasten drücken …') : binds[a.id] ? binds[a.id]!.split('+').map((k, i) => <kbd key={i}>{k === 'Ctrl' ? tr('Ctrl', 'Strg') : k}</kbd>) : tr('Not set', 'Nicht festgelegt')}
            </button>
            {binds[a.id] ? <button type="button" className="keybind-clear" title={tr('Remove', 'Entfernen')} onClick={() => clear(a.id)}><X size={14} /></button> : <span className="keybind-clear-placeholder" />}
          </div>
        ))}
      </div>
    </>
  );
}
